import { render, staticRenderFns } from "./articleForm.vue?vue&type=template&id=3e241bbb&scoped=true&"
import script from "./articleForm.vue?vue&type=script&lang=js&"
export * from "./articleForm.vue?vue&type=script&lang=js&"
import style0 from "./articleForm.vue?vue&type=style&index=0&id=3e241bbb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e241bbb",
  null
  
)

export default component.exports